module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classAlert) ? _c('div', {
    staticClass: "class-alert",
    class: _vm.alertLevel
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'course',
        params: {
          courseId: _vm.course.instanceid
        }
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.course.name))]), _vm._v(" "), (_vm.classAlert === 'inSession') ? _c('span', [_vm._v("In Session")]) : _c('span', [_vm._v(" starting in " + _vm._s(_vm.setClassAlert))])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e10e2888!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CourseCountdown.vue
// module id = 2111
// module chunks = 2